"use client";

import { Globe2, MapPin, ShieldCheck } from "@/components/icons";
import type { StatItem } from "@/components/ui/stat-card";

export const residentialStats: StatItem[] = [
  {
    icon: Globe2,
    value: 100,
    suffix: "M+",
    label: "Residential IPs",
    color: "color-mix(in srgb, var(--foreground) 70%, transparent)",
  },
  {
    icon: MapPin,
    value: 195,
    suffix: "+",
    label: "Countries covered",
    color: "color-mix(in srgb, var(--foreground) 70%, transparent)",
  },
  {
    icon: ShieldCheck,
    value: 99.9,
    suffix: "%",
    label: "Success rate",
    color: "color-mix(in srgb, var(--foreground) 60%, transparent)",
    isFloat: true,
  },
];
